import {Fragment, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';
import DotsLoading from '../../../../components/dotsLoading';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import useGetCardNumber from '../../../../services/hookService/getCardNumber/useGetCardNumber';
import convertNumberToPersianExactUnits from '../../../../utilities/helper/unitConvertor/convertNumberToPersianExactUnits';
import {useCreateCardToCardTransaction} from '../hooks/useCreateCardToCardTransaction';
import {PaymentMethodValues, TransactionTypesChoices} from '../utils/helpers';
import CardNumberItem from './CardNumberItem';
import ReceiptImageUpload from './ReceiptImageUpload';
interface IState {
  transactionType?: TransactionTypesChoices;
  paymentType?: PaymentMethodValues;
  price?: string;
}

const CardToCardPage = () => {
  const navigate = useNavigate();
  const {orderGuid, storeOrderGuid} = useParams();

  const {state} = useLocation();

  const {paymentType, transactionType, price} = state as IState;

  const [uploadedImage, setUploadedImage] = useState<File | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const {data, cadNumberIsLoading} = useGetCardNumber('ملی');

  const handleSuccess = () => {
    setIsOpen(true);
  };

  const {mutate, isSuccess, isLoading} = useCreateCardToCardTransaction({
    transactionType,
    paymentType,
    orderGuid,
    storeOrderGuid,
    image: uploadedImage,
    handleAfterSuccess: handleSuccess,
  });

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">پرداخت</span>
          </div>
        )}
      />

      {/* Page Content */}
      <div className="flex flex-col w-full h-full gap-3 p-6 overflow-y-auto">
        <span className="text-sm font-medium text-neutral-600">
          پرداخت کارت به کارت
        </span>

        <p className="pb-0 mb-0 text-sm text-zinc-800">
          مبلغ {convertNumberToPersianExactUnits(price ?? 0)} را به یکی از شماره
          کارت‌های زیر انتقال دهید سپس تصویر رسید را ارسال کنید.
        </p>

        {cadNumberIsLoading && <DotsLoading />}
        <div className="mb-4 space-y-2">
          {data?.map((cardNum: ICardNumber, index) => (
            <Fragment key={index}>
              <CardNumberItem
                logo={cardNum.bank_logo || ''}
                cardNumber={cardNum.card_number}
                cardShabaNumber={cardNum.shaba_number || ''}
              />
            </Fragment>
          ))}
        </div>

        <ReceiptImageUpload
          setUploadedImage={setUploadedImage}
          uploadedImage={uploadedImage}
        />
      </div>

      {/* Page Action Button */}
      <div className=" w-full px-4  flex  bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
        <button
          type="button"
          className="flex items-center justify-center w-full h-12 mb-4 text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700 text-md"
          disabled={!Boolean(uploadedImage)}
          onClick={() => mutate()}
        >
          {isLoading ? <DotsLoading /> : 'تایید'}
        </button>
      </div>

      <BottomSheet
        onDismiss={() => {
          if (isSuccess) navigate('/my-orders', {replace: true});
          setIsOpen(false);
        }}
        open={isOpen}
        blocking={true}
        className="custom-bottom-sheet"
      >
        <div className="relative flex flex-col w-full gap-3 px-3 py-6 CalenderWrapperBottomSheet-wrapper">
          <i
            className="absolute text-2xl text-gray-500 icon-nameClose-remove top-4 left-6"
            onClick={() => setIsOpen(false)}
          />
          <p className="flex justify-center w-full p-0 m-0 mb-6 font-medium text-md text-zinc-500">
            بررسی فیش پرداخت
          </p>

          <div className="flex justify-between w-full px-2 py-3 text-sm text-neutral-500 ">
            <span>
              تصویر فیش پرداخت شما بارگذاری شد و توسط کارشناسان ما در حال بررسی
              است. نتیجه از طریق پیامک اطلاع داده می‌شود.
            </span>
          </div>

          <div className="flex items-center justify-between w-full px-3">
            <div className="flex justify-end w-full">
              <Button
                className="flex items-center w-full gap-2 text-white border-none outline-none bg-farm-shop-500"
                onClick={() => navigate('/my-orders', {replace: true})}
              >
                متوجه شدم
              </Button>
            </div>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default CardToCardPage;
